import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CartItem, IMenuCategoryDto, IScheduleMenuDto } from '../models';
import { CommonConstants } from 'src/app/shared/constant';
import { EncryptionService } from './encryption.service';

@Injectable()
export class MenuService extends ApiService {
  private readonly cartKey: string = CommonConstants.menuKey;

  private currentCartSubject: BehaviorSubject<CartItem[]>;
  public currentCart: Observable<CartItem[]>;

  constructor(
    http: HttpClient,
    errorHandler: ErrorHandler,
    private encryptionService: EncryptionService
  ) {
    super(http, errorHandler);
    this.currentCartSubject = new BehaviorSubject<CartItem[]>(this.getCart());
    this.currentCart = this.currentCartSubject.asObservable();
  }

  public get currentCartValue(): CartItem[] {
    return this.currentCartSubject.value;
  }

  public setCurrentCart(cart: CartItem[], isLongTerm: boolean): void {
    this.currentCartSubject.next(cart);

    //const json = JSON.stringify(cart);
    const json = this.encryptionService.setJson(cart);

    if (isLongTerm) {
      localStorage.setItem(this.cartKey, json);
    } else {
      sessionStorage.setItem(this.cartKey, json);
    }
  }

  public getCart(): CartItem[] {
    let storedCart: any = localStorage.getItem(this.cartKey);

    if (storedCart == null) {
      storedCart = sessionStorage.getItem(this.cartKey);
    }

    if (storedCart == null) {
      return null;
    }

    //const json: any = JSON.parse(storedCart);
    const json = this.encryptionService.getJson(storedCart);
    const client: CartItem[] = json;

    return client;
  }

  public removeCart(): void {
    localStorage.removeItem(this.cartKey);
    sessionStorage.removeItem(this.cartKey);
  }

  public getMenuList(model: IScheduleMenuDto): Observable<IMenuCategoryDto[]> {
    return this.post(`menu`, model);
  }
}
